import React from 'react';
import { __ } from '../../../Utils';
import { connect, actions } from '../../../Store';
import BaseMarketingLayout from '../BaseList';
import CompanyDetails from '../../CompanyDetails';

class Company extends BaseMarketingLayout {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      title: __('Spoločnosť'),
      isProduct: false,
      loading: false,
      showFilter: false,
      showPager: false,
      items: [''],
    };

    actions.setActiveMenuItem('92');
  }

  renderItemsList() {
    return <CompanyDetails />;
  }

  render() {
    return super.render();
  }
}

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(Company);



// WEBPACK FOOTER //
// ./src/Containers/Settings/Company/index.jsx